module.exports = __webpack_public_path__ + "static/media/logo-login.6595b33c.png";